import React from "react";
import { useHistory } from "react-router-dom";

function TaxonomyIndex(props) {
  const history = useHistory();
  return (
    <React.Fragment>
      <div className="container-fluid">
        <h2>Dashboard</h2>
        <hr />
        <div className="row">

          <div className="col-sm-4">
            <div className="mb-3 card border-dark">
              <div className="card-body text-dark">
                <h5 className="card-title">Categories</h5>
                <p className="card-text">
                  Categories
                </p>
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => history.replace("/gms/taxonomy/category")}
                >
                  Explore
                </button>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="mb-3 card border-dark">
              <div className="card-body text-dark">
                <h5 className="card-title">Attributes</h5>
                <p className="card-text">Attributes</p>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => history.replace("/gms/taxonomy/attribute")}
                >
                  Explore
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default TaxonomyIndex;
